module.exports = __webpack_public_path__ + "img/step1.1f508408.svg";